const getters = {
  token: state => state.app.token,
  avatar: state => state.app.avatar,
  nickname: state => state.app.nickname,
  mobile: state => state.app.mobile,
  email: state => state.app.email
}


export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js